import type { CalloutBlock, LocaleCode } from '@fixit/bozp-content';
import { Markdown } from '../markdown';

export function CalloutBlockView({ block, locale }: { block: CalloutBlock; locale: LocaleCode }) {
  return (
    <aside data-block-type="callout" data-callout-variant={block.variant} role="note">
      <Markdown markdown={block.markdown} locale={locale} />
    </aside>
  );
}
